// Cart Drawer For Upsell Products
$(document).ready(function () {
  $("[data-ajax-cart-trigger]").on("click", function () {
    $(".cartUpsellContainer").show();
    let upSellSliderElements = document.querySelectorAll(
      ".cartUpsellContainer .cartUpsellProdBox"
    );
    upSellSliderElements.forEach(function (upSellSliderElement) {
      if (
        upSellSliderElement &&
        !$(upSellSliderElement).hasClass("flickity-enabled")
      ) {
        let upSellSlider = new Flickity(upSellSliderElement, {
          accessibility: true,
          resize: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: true,
          percentPosition: true,
          setGallerySize: true,
          cellAlign: 'left'
        });

        upSellSlider.on('settle', function () {
          upSellSlider.resize();
        });

        setTimeout(function () {
          upSellSlider.resize();
        }, 500);
      }
    });
});
});

$(document).ready(function () {
  function checkAndAddClass() {
    $(".upsellInnerContainer").each(function () {
      var containerId = $(this).attr("id");
      var matchingProduct = false;
      $(".ajax-cart__list .ajax-cart__product").each(function () {
        var prodId = $(this).data("prod-id");
        if (containerId == prodId) {
          matchingProduct = true;
          return false;
        }
      });
      if (matchingProduct) {
        $(this).addClass("FadedProd");
      } else {
        $(this).removeClass("FadedProd");
      }
    });
  }
  checkAndAddClass();
  setInterval(checkAndAddClass, 3000);
});
// Cart Drawer For Upsell Products - End

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.matchMedia({
  // Desktop (1200px and up)
  "(min-width: 1200px)": function() {
    // Pinning for large screens
    ScrollTrigger.create({
      trigger: ".fixed-image-container",
      start: "top top+=117",
      end: "bottom 0px",
      pin: true,
      scrub: true
    });
    
    // Ball animation for large screens
    gsap.to(".ball", {
      y: "65vh",
      scrollTrigger: {
        trigger: ".fixed-image-container",
        start: "top top+=117",
        end: "bottom top",
        scrub: true
      }
    });
  },
  
  // Medium screens (799px to 1199px)
  "(min-width: 799px) and (max-width: 1199px)": function() {
    // Pinning for medium screens
    ScrollTrigger.create({
      trigger: ".fixed-image-container",
      start: "top top+=117",
      end: "bottom top",
      pin: true,
      scrub: true
    });
    
    // Ball animation for medium screens
    gsap.to(".ball", {
      y: "55vh",
      scrollTrigger: {
        trigger: ".fixed-image-container",
        start: "top top+=117",
        end: "bottom top",
        scrub: true
      }
    });
  },
  
  "(max-width: 798px)": function() {
    // Pinning for mobile
    ScrollTrigger.create({
      trigger: ".fixed-image-container",
      start: "top top+=117",
      end: "bottom top",
      pin: true,
      scrub: true
    });
    
    // Ball animation for mobile
    gsap.to(".ball", {
      y: "62vh",
      scrollTrigger: {
        trigger: ".fixed-image-container",
        start: "top top+=127",
        end: "bottom top",
        scrub: true
      }
    });
  },
  
  "(max-width: 600px)": function() {
    // Ball animation for mobile
    gsap.to(".ball", {
      y: "60vh",
      scrollTrigger: {
        trigger: ".fixed-image-container",
        start: "top top+=127",
        end: "bottom top",
        scrub: true
      }
    });
  }
});

// ScrollTrigger.create({
//   trigger: ".fixed-image-container",
//   start: "top top+=117",
//   end: "bottom top",
//   pin: true, 
//   scrub: true,
// });

$(document).ready(function() {
  function handleFooterAccordionClick() {
    var windowWidth = $(window).width();
    
    if (windowWidth < 799) {
      var $this = $(this);
      $this.toggleClass('active');
      
      var $currentBlock = $this.closest('.footer__block');
      
      if ($currentBlock.hasClass('four')) {
        $currentBlock.find('.footer__menu ul').slideToggle();
      } else {
        $this.next().slideToggle();
      }
    }
  }

  $(".footer__content .footer__block .footer__heading").on('click', handleFooterAccordionClick);
});

$(document).on('click', '.back-btn', function() {
  var submenuInput = $(this).parent().parent().parent().parent().parent().find('#mobile-submenu-bats');
  if (submenuInput.prop('checked')) {
    submenuInput.prop('checked', false).trigger('change');
  } 
});

$(document).on('click', '.back-btn', function () {
  const $container = $(this).closest('.mobile-menu__list');

  const submenuIds = [
    '#mobile-submenu-bats',
    '#mobile-submenu-balls',
    '#mobile-submenu-equipment',
    '#mobile-submenu-accessories',
    '#mobile-submenu-apparel',
    '#mobile-submenu-footwear',
    '#mobile-submenu-training-field',
    '#mobile-submenu-closeouts'
  ];

  submenuIds.forEach(function (id) {
    const $input = $container.find(id);
    if ($input.prop('checked')) {
      $input.prop('checked', false).trigger('change');
    }
  });
});